export default "__VITE_ASSET__CuTaP7xL__"